/* hh-blog.js — Blog index + article sliders.
   Lean, idempotent. No innerHTML. Loaded in-section by hh-blog/hh-article.

   1. initSlider()      — blog index "more to read": scrollBy on a scroll-snap track.
   2. initArticleLoop() — article "You may also enjoy": an infinite translateX loop
                          on desktop (ports Blog.jsx PostSlider); native scroll on mobile.
*/
(function () {
  'use strict';

  if (window.__hhBlogInit) return;
  window.__hhBlogInit = true;

  /* ── Infinite-loop post slider — shared by the article "You may also enjoy"
        AND the blog index "More to read" (both port Blog.jsx PostSlider): an
        infinite translateX loop on desktop, native scroll on mobile. ───── */
  function initLoop(trackId, prevSel, nextSel) {
    var POST_GAP = 40, POST_COLS = 2, POST_PEEK = 0.25;

    var track = document.getElementById(trackId);
    if (!track) return;
    var wrap = track.parentElement; // .hh-X__more-track-wrap
    var prevBtn = document.querySelector(prevSel);
    var nextBtn = document.querySelector(nextSel);
    var originals = Array.prototype.slice.call(track.children);
    var N = originals.length;
    if (N === 0 || !prevBtn || !nextBtn) return;

    var mq = window.matchMedia('(min-width: 768px)');
    var built = false, offset = 0, slotPx = 0, animating = false;

    function measure() {
      var W = wrap.clientWidth;
      slotPx = (W + POST_PEEK * POST_GAP) / (POST_COLS + POST_PEEK);
      var itemW = slotPx - POST_GAP;
      Array.prototype.slice.call(track.children).forEach(function (el) {
        el.style.flex = '0 0 ' + itemW + 'px';
      });
    }

    // Jump to the current offset with no animation, then restore the CSS transition.
    function jump() {
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-offset * slotPx) + 'px)';
      track.offsetWidth; // force reflow
      track.style.transition = '';
    }

    function build() {
      if (built) return;
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (el) { before.appendChild(el.cloneNode(true)); });
      originals.forEach(function (el) { after.appendChild(el.cloneNode(true)); });
      track.insertBefore(before, originals[0]);
      track.appendChild(after);
      offset = N;             // start at the middle copy
      built = true;
      measure();
      jump();
    }

    function teardown() {
      if (!built) return;
      Array.prototype.slice.call(track.children).forEach(function (el) {
        if (originals.indexOf(el) === -1) track.removeChild(el);
        else el.style.flex = '';   // restore CSS flex-basis
      });
      track.style.transform = '';
      track.style.transition = '';
      built = false;
    }

    function slide(dir) {
      if (!built || animating) return;
      offset += dir;
      animating = true;
      track.style.transition = '';   // ensure CSS transition active
      track.style.transform = 'translateX(' + (-offset * slotPx) + 'px)';
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      animating = false;
      // Teleport back into the middle copy range [N, 2N) when we've drifted out.
      if (offset < N || offset >= 2 * N) {
        offset = (((offset - N) % N) + N) % N + N;
        jump();
      }
    });

    prevBtn.addEventListener('click', function () { slide(-1); });
    nextBtn.addEventListener('click', function () { slide(1); });

    function sync() { mq.matches ? build() : teardown(); }
    sync();
    mq.addEventListener('change', sync);
    window.addEventListener('resize', function () {
      if (!built) return;
      measure();
      jump();
    });
  }

  /* ── 3. Polaroids: wrap bare images, tag figures, alternate sides ───── */
  function initPolaroids() {
    var body = document.querySelector('.hh-article__body');
    if (!body || body.dataset.hhFigs) return;
    body.dataset.hhFigs = '1';

    // Remove empty spacer paragraphs (rich-text editor artifacts: <p></p>,
    // <p>&nbsp;</p>, <p><br></p>). They inject inconsistent vertical gaps — most
    // visibly an ~80px hole between a heading and a following floated image,
    // because floats don't margin-collapse past them. The mockup body has none;
    // paragraph margins handle spacing.
    Array.prototype.slice.call(body.querySelectorAll('p')).forEach(function (p) {
      if (!p.textContent.trim() && !p.querySelector('img, iframe, video, picture, svg')) {
        p.parentNode.removeChild(p);
      }
    });

    // Wrap bare images (not already in a figure or a table) so every image
    // block is a uniform .hh-fig container.
    Array.prototype.slice.call(body.querySelectorAll('img')).forEach(function (im) {
      if (im.closest('figure') || im.closest('table') || im.closest('.hh-fig')) return;
      var w = document.createElement('div');
      w.className = 'hh-fig';
      im.parentNode.insertBefore(w, im);
      w.appendChild(im);
    });

    // ── Adopt orphaned captions ──
    // Most posts use a proper <figure>/<figcaption>. A handful were authored with the caption as
    // ordinary body text, so it stranded next to the floated image instead of landing on the mat.
    // Two shapes exist in the live content:
    //   A.  <p><img><br><br><em>caption</em></p>      caption trails the image in the SAME <p>
    //   B.  <p><img></p><p><em>caption</em></p>       caption is the NEXT <p>, wholly italic
    //
    // Italic alone is NOT sufficient evidence: some posts follow an image with an italic pull
    // quote, a Scripture passage, or a long book blurb — body copy that must stay in the column.
    // So a run only counts as a caption if it is short and does not open with a quotation mark.
    // (Measured against all 50 live posts: this adopts 5 real captions and rejects the 3 long
    // italic body runs, including an 11k-character Scripture quote.)
    var MAX_CAPTION = 300;

    function looksLikeCaption(text) {
      var t = (text || '').trim();
      return t.length > 0 && t.length <= MAX_CAPTION && !/^["'“‘]/.test(t);
    }

    // Move (don't copy) the nodes onto the mat, so <em> and any links survive.
    function attachCaption(fig, nodes) {
      var cap = document.createElement('figcaption');
      nodes.forEach(function (n) { cap.appendChild(n); });
      fig.appendChild(cap);
    }

    Array.prototype.slice.call(body.querySelectorAll('.hh-fig')).forEach(function (fig) {
      if (fig.querySelector('figcaption')) return;              // already captioned
      var p = fig.parentNode;
      if (!p || p.tagName !== 'P') return;                      // only the bare-img-in-<p> case

      var trailing = [];
      for (var n = fig.nextSibling; n; n = n.nextSibling) trailing.push(n);
      var trailingText = trailing.map(function (x) { return x.textContent || ''; }).join('');

      if (trailingText.trim()) {
        // A — caption sits after the image inside this same paragraph.
        if (looksLikeCaption(trailingText)) {
          var keep = trailing.filter(function (x) {
            if (x.nodeType === 1 && x.tagName === 'BR') { x.parentNode.removeChild(x); return false; }
            return !(x.nodeType === 3 && !x.textContent.trim());  // drop whitespace-only text nodes
          });
          attachCaption(fig, keep);
        }
      } else {
        // B — the paragraph holds only the image; check whether the next one is its caption.
        trailing.forEach(function (x) {
          if (x.nodeType === 1 && x.tagName === 'BR') x.parentNode.removeChild(x);
        });
        var sib = p.nextElementSibling;
        if (sib && sib.tagName === 'P') {
          // Rich-text paste artifacts (<meta charset>, stray <link>/<style>) sit INSIDE the
          // caption paragraph in several posts. They render nothing, so they must not count
          // against "is this paragraph wholly italic?" — three captions were missed this way.
          Array.prototype.slice.call(sib.querySelectorAll('meta, link, style, script')).forEach(
            function (junk) { junk.parentNode.removeChild(junk); }
          );
          var kids = Array.prototype.filter.call(sib.childNodes, function (x) {
            if (x.nodeType === 1) return x.tagName !== 'BR';
            return x.nodeType === 3 && x.textContent.trim();
          });
          var whollyItalic = kids.length === 1 && kids[0].nodeType === 1 && /^(EM|I)$/.test(kids[0].tagName);
          if (whollyItalic && looksLikeCaption(sib.textContent)) {
            attachCaption(fig, [kids[0]]);
            sib.parentNode.removeChild(sib);
          }
        }
      }

      // The <p> is now a bare wrapper around the figure. Hoist the figure out and drop the
      // paragraph, so the float resolves against the body column rather than inside a <p>.
      var leftovers = Array.prototype.filter.call(p.childNodes, function (x) {
        return x !== fig && (x.nodeType === 1 || (x.nodeType === 3 && x.textContent.trim()));
      });
      if (leftovers.length === 0) {
        p.parentNode.insertBefore(fig, p);
        p.parentNode.removeChild(p);
      }
    });

    // Figures join the same class; drop their inline layout styles so the CSS
    // alternation wins (content ships float:right / max-width / padding inline).
    Array.prototype.slice.call(body.querySelectorAll('figure')).forEach(function (fig) {
      fig.classList.add('hh-fig');
      fig.removeAttribute('style');
      var cap = fig.querySelector('figcaption');
      if (cap) cap.removeAttribute('style');

      // Some posts ship the caption text as a bare <em> NEXT TO an empty <figcaption>:
      //   <figure><img><figcaption></figcaption><em>Cathedral Church of St Brigid</em></figure>
      // It's inside the figure but outside the caption element, so it renders as body serif
      // instead of the handwritten face. Move any stray content into the caption.
      if (!cap || !cap.textContent.trim()) {
        var strays = Array.prototype.filter.call(fig.childNodes, function (x) {
          if (x.nodeType === 1) {
            return !/^(IMG|PICTURE|SOURCE|FIGCAPTION|BR|META|LINK|STYLE|SCRIPT)$/.test(x.tagName);
          }
          return x.nodeType === 3 && x.textContent.trim();
        });
        if (strays.length) {
          if (!cap) { cap = document.createElement('figcaption'); fig.appendChild(cap); }
          strays.forEach(function (n) { cap.appendChild(n); });
          fig.appendChild(cap);   // keep the caption last, below the image on the mat
        }
      }
      // An empty figcaption still claims its top padding — drop it.
      if (cap && !cap.textContent.trim()) cap.parentNode.removeChild(cap);
    });

    // Strip inline styles off every image on a mat. The posts ship
    //   style="float: right; max-width: 500px; padding-left: 24px"
    // on the <img> itself. Inline styles BEAT the stylesheet, so `.hh-fig img { max-width: none }`
    // loses and that 24px padding lands INSIDE the white mat — the excess inner-edge gap. The
    // float/width belong to the .hh-fig wrapper now, so the image needs none of it.
    Array.prototype.slice.call(body.querySelectorAll('.hh-fig img')).forEach(function (im) {
      im.removeAttribute('style');
      im.removeAttribute('width');
      im.removeAttribute('height');
    });

    // Alternate sides in document order: 1st right, 2nd left, 3rd right…
    Array.prototype.slice.call(body.querySelectorAll('.hh-fig')).forEach(function (el, i) {
      el.classList.add(i % 2 === 0 ? 'hh-fig--right' : 'hh-fig--left');
    });
  }

  function init() {
    initLoop('hh-article-track', '.hh-article__more-arrow--prev', '.hh-article__more-arrow--next');
    initLoop('hh-blog-track', '.hh-blog__more-arrow--prev', '.hh-blog__more-arrow--next');
    initPolaroids();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
